import { render, staticRenderFns } from "./TabFiscal.vue?vue&type=template&id=08d8b100&"
import script from "./TabFiscal.vue?vue&type=script&lang=js&"
export * from "./TabFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports